/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Typography,
  Container,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LoginIcon from "@mui/icons-material/Login";
import { PUBLIC_COLORS } from "assets/theme/publicTokens";

function PublicNavbar() {
  const navigate = useNavigate();
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  // Navigation items
  const navItems = [
    { label: "Hakkımızda", path: "/hakkimizda" },
    { label: "Hizmetlerimiz", path: "/hizmetlerimiz" },
    { label: "Blog", path: "/blog" },
    { label: "İlanlar", path: "/ilanlar" },
    { label: "Emlak Ofisleri", path: "/emlak-ofisleri" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        position: "relative", // Changed from absolute to relative to stay in flow
        top: 0,
        zIndex: 1100,
        px: 0,
      }}
    >
      <AppBar
        position="static"
        sx={{
          backgroundColor: PUBLIC_COLORS.surface,
          boxShadow: "0 4px 18px rgba(15, 23, 42, 0.06)",
          borderRadius: 0,
          border: 0,
          borderBottom: `1px solid ${PUBLIC_COLORS.border}`,
          transition: "all 0.3s ease-in-out",
          width: "100%",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{
              minHeight: "70px",
              justifyContent: "space-between",
            }}
          >
            {/* Logo */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexGrow: { xs: 1, md: 0 },
                cursor: "pointer",
              }}
              onClick={() => navigate("/")}
            >
              <Box
                component="img"
                src={require("assets/images/renix-logo-512x512.png")}
                alt="Renix Logo"
                sx={{
                  width: { xs: "54px", md: "64px" },
                  height: "auto",
                }}
              />
            </Box>

            {/* Desktop Navigation */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                gap: { md: 1, lg: 2 },
                flexGrow: 1,
                justifyContent: "center",
              }}
            >
              {navItems.map((item) => (
                <Button
                  key={item.label}
                  component={Link}
                  to={item.path}
                  sx={({ palette: { info }, functions: { rgba } }) => ({
                    color: info.main,
                    fontWeight: "600",
                    fontSize: "0.875rem",
                    textTransform: "none",
                    borderRadius: "10px",
                    px: 2,
                    py: 1,
                    transition: "all 0.2s",
                    "&:hover": {
                      backgroundColor: rgba(info.main, 0.08),
                      color: info.main,
                      transform: "translateY(-1px)",
                    },
                  })}
                >
                  {item.label}
                </Button>
              ))}
            </Box>

            {/* Desktop Login Button */}
            <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
              <Button
                variant="contained"
                startIcon={<LoginIcon />}
                component={Link}
                to="/authentication/sign-in"
                sx={({ palette: { white } }) => ({
                  textTransform: "none",
                  backgroundColor: PUBLIC_COLORS.blue,
                  color: white.main,
                  fontWeight: "bold",
                  borderRadius: "10px",
                  px: 3,
                  py: 1,
                  boxShadow: "0 8px 20px rgba(0, 114, 212, 0.2)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: PUBLIC_COLORS.blueHover,
                    boxShadow: "0 10px 24px rgba(0, 114, 212, 0.26)",
                    transform: "translateY(-2px)",
                  },
                })}
              >
                Giriş Yap
              </Button>
            </Box>

            {/* Mobile Menu Button */}
            <Box sx={{ display: { xs: "flex", md: "none" }, alignItems: "center", gap: 2 }}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls="mobile-menu"
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                sx={({ palette: { info }, functions: { rgba } }) => ({
                  color: info.main,
                  background: rgba(info.main, 0.05),
                  borderRadius: "10px",
                  "&:hover": { background: rgba(info.main, 0.1) },
                })}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Menu */}
      <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id="mobile-menu"
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
        PaperProps={{
          sx: {
            display: { xs: "block", md: "none" },
            width: "220px",
            mt: 1.5,
            boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
            borderRadius: "16px",
            backdropFilter: "blur(20px)",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            border: "1px solid rgba(255,255,255,0.8)",
            p: 1,
          },
        }}
      >
        {navItems.map((item) => (
          <MenuItem
            key={item.label}
            component={Link}
            to={item.path}
            onClick={handleMobileMenuClose}
            sx={({ palette: { dark, info }, functions: { rgba } }) => ({
              color: dark.main,
              fontWeight: "600",
              py: 1.5,
              px: 2,
              borderRadius: "8px",
              mb: 0.5,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: rgba(info.main, 0.08),
                color: info.main,
                transform: "translateX(4px)",
              },
            })}
          >
            {item.label}
          </MenuItem>
        ))}
        <MenuItem
          component={Link}
          to="/authentication/sign-in"
          onClick={handleMobileMenuClose}
          sx={({ palette: { white } }) => ({
            color: white.main,
            backgroundColor: PUBLIC_COLORS.blue,
            py: 1.2,
            px: 2,
            mt: 1,
            borderRadius: "8px",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            boxShadow: "0 8px 20px rgba(0, 114, 212, 0.2)",
            "&:hover": {
              backgroundColor: PUBLIC_COLORS.blueHover,
            },
          })}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LoginIcon fontSize="small" />
            Giriş Yap
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default PublicNavbar;
